import {
  Box,
  FormGroup,
  Table,
  TableBody,
  TableHead,
  TableRow,
  styled,
  TableCell,
  TableContainer,
  Paper,
  Avatar,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "./LeadReportCreation.module.css";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import dayjs from "dayjs";
import LineChart from "../../../Dashboard/components/LineChart/LineChart";
import PieChart from "../../../../../components/PieChart/PieChart";
import CustomFilterAccordion from "../../../../../components/CustomFilterAccordion/CustomFilterAccordion";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterSearchField from "../../../../../components/FilterDrawer/FilterSearchField/FilterSearchField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CancelBtn from "../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import { useLocation, useNavigate } from "react-router-dom";
import IconDropdown from "../../../../../components/Dropdowns/IconDropdown";
import SaveReportPopup from "../SaveReportPopup/SaveReportPopup";
import CancelModal from "../../../../../components/CancelModal/CancelModal";
import CourseDescriptionSkeleton from "../../../../../components/Skeletons/Course/CourseDescriptionSkeleton";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import { useDispatch } from "react-redux";
import { getDescriptionWithMentionedNames } from "../../../../../components/CommonFunctions/CommonFunctions";
import { resetDownloadReportSuccess } from "../../service/reportCreationSlice";
import AttendanceSkeleton from "../../../../../components/Skeletons/Attendance/AttendanceSkeleton";
import accordionDown from "../../../../../assets/images/accordion-down.svg";
import { DownloadReport } from "../../service/reports.request";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import PageBackBtn from "../../../../../components/Buttons/PageBackBtn";
import moment from "moment";
import { resetReportStatuses } from "../../service/reportsSlice";
// import { List } from "react-window";
interface CheckedBranch {
  id: string;
  branchName: string;
}

interface CheckedCourse {
  id: string;
  courseName: string;
}

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  lineHeight: "18px",
  backgroundColor: "#073E53",
  color: "#FFFFFF",
  textTransform: "capitalize",
  fontWeight: "400",
  fontSize: 14,
  padding: 16,
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "12px",
  color: "#667085",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

const LeadReportCreation = (props: any) => {
  const {
    GetDefaultReport,
    SaveReport,
    getDefaultReportData,
    getDefaultReportDataLoading,
    saveReportLoading,
    saveReportSuccess,
    // DownloadReport,
    downloadReportData,
    downloadReportSuccess,
    getDefaultReportDataSuccess,
    GetLeadReportById,
    getLeadReportByIdLoading,
    getLeadReportByIdData,
  } = props;
  const dispatch = useDispatch();
  const auth = useAuthUser();
  const user = auth();
  const navigate = useNavigate();
  const location = useLocation();
  localStorage.setItem("isFromView", location?.state?.isFromView);
  localStorage.setItem("from", location?.state?.from);
  const { userById } = useSelector((state: any) => state.userDetails);

  const [checkedCourses, setCheckedCourses] = useState<any[]>([]);
  const [checkedBranches, setCheckedBranches] = useState<any[]>([]);
  const [showAllCourses, setShowAllCourses] = useState<boolean>(false);
  const [showAllBranches, setShowAllBranches] = useState<boolean>(false);
  const branches = useSelector((state: any) => state.branch.branchList);
  const courses = useSelector((state: any) => state.courses.courses);
  const batchList = useSelector((state: any) => state.batch.batchList);
  const [isBranchOpen, setIsBranchOpen] = useState(false);
  const [isBatchOpen, setIsBatchOpen] = useState(false);
  const [isCourseOpen, setIsCourseOpen] = useState(false);
  const [isAssigneeOpen, setIsAssigneeOpen] = useState(false);
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [isProfileTagOpen, setIsProfileTagOpen] = useState(false);

  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isStageOpen, setIsStageOpen] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [checkedSource, setCheckedSource] = useState<any[]>([]);
  const [checkedStage, setCheckedStage] = useState<any[]>([]);
  const [checkedStatus, setCheckedStatus] = useState<any[]>([]);
  const [checkedProfileTags, setCheckedProfileTags] = useState<any[]>([]);
  const [checkedTags, setCheckedTags] = useState<any[]>([]);
  const [assigneeSearchTerm, setAssigneeSearchTerm] =
    React.useState<string>("");
  const [batchSearchTerm, setBatchSearchTerm] = React.useState<string>("");
  const [branchSearchTerm, setBranchSearchTerm] = React.useState<string>("");
  const [tagSearchTerm, setTagSearchTerm] = React.useState<string>("");
  const [sourceSearchTerm, setSourceSearchTerm] = React.useState<string>("");
  const [stageSearchTerm, setStageSearchTerm] = React.useState<string>("");

  const [showAllEmployees, setShowAllEmployees] =
    React.useState<boolean>(false);
  const [showAllBranch, setShowAllBranch] = React.useState<boolean>(false);
  const [showAllBatch, setShowAllBatch] = React.useState<boolean>(false);
  const [checkedBatches, setCheckedBatches] = useState<any[]>([]);
  const [courseSearchTerm, setCourseSearchTerm] = React.useState("");
  const courseList: any = useSelector((state: any) => state.courses.courses);
  const employees = useSelector((state: any) => state.staff.staffList);
  const [checkedAssignees, setCheckedAssignees] = useState<any[]>([]);
  const [checkedDateRange, setCheckedDateRange] = useState<any[]>([]);
  const [startDate, setStartDate] = React.useState<any>(dayjs().unix() * 1000);
  const [endDate, setEndDate] = React.useState<number | null>(
    dayjs().unix() * 1000
  );
  const [openSaveReportPopup, setOpenSaveReportPopup] = useState(false);
  const [reportName, setReportName] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  const [reportTableData, setReportTableData] = useState<any>();
  const [cancel, setCancel] = useState(false);
  const { getLatestReports } = useSelector(
    (state: any) => state?.websocketNotifications
  );
  const [isFromView, setIsFromView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [collapseGraph, setCollapseGraph] = useState(false);
  const [showClearAll, setShowClearAll] = useState(false);
  const isCompress = useSelector((state: any) => state.compress.isCompress);
  const [isAdimnDataModified, setIsAdminDataModified] = useState(false);
  const [loadingForAdmin, setLoadingForAdmin] = useState(false);
  const [graphValues, setGraphValues] = useState<any>();

  const subCategory = [
    { tag: "All", id: "0" },
    { tag: "Contact", id: "1" },
    { tag: "Lead", id: "2" },
    { tag: "Student", id: "3" },
  ];
  const customDurationArray = [
    { duration: "Today", id: "0" },
    { duration: "Last 7 days", id: "1" },
    { duration: "Last 15 Days", id: "2" },
    { duration: "Last 30 Days", id: "3" },
    { duration: "Custom Date", id: "4" },
  ];
  const profileTags = [
    { label: "Select", value: "SELECT" },
    { label: "Cold", value: "COLD" },
    { label: "Warm", value: "WARM" },
    { label: "Hot", value: "HOT" },
    { label: "Followup", value: "FOLLOWUP" },
    { label: "Invalid", value: "INVALID" },
    { label: "Qualified", value: "QUALIFIED" },
    { label: "Disqualified", value: "DISQUALIFIED" },
    { label: "Not Answering", value: "NOT_ANSWERING" },
    { label: "Interested", value: "INTERESTED" },
    { label: "Not Interested", value: "NOT_INTERESTED" },
    { label: "Future Prospect", value: "FUTURE_PROSPECT" },
    { label: "Budget Constraint", value: "BUDGET_CONSTRAINT" },
    { label: "Not Reachable", value: "NOT_REACHABLE" },
    { label: "Lost", value: "LOST" },
    { label: "Shortlisted", value: "SHORTLISTED" },
    { label: "Admission", value: "ADMISSION" },
    { label: "Exam Schedule", value: "EXAM_SCHEDULE" },
    { label: "Placement Done", value: "Placement_Done" },
    { label: "Flexi Payment Plan", value: "FLEXI_PAYMENT_PLAN" },
    { label: "Callback", value: "CALLBACK" },
    { label: "Discontinued", value: "DISCONTINUED" },
    { label: "Discontinued and Refunded", value: "DISCONTINUED_REFUNDED" },
  ];
  const status = [
    { type: "ACTIVE", option: "Active" },
    { type: "LOST", option: "Lost" },
  ];

  useEffect(() => {
    setIsFromView(localStorage.getItem("isFromView") === "true" ? true : false);
  }, []);

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const { leadBoard } = useSelector((state: any) => state.nurture);

  const swimlaneData = leadBoard?.swimlaneData
    .map((item: any) => ({
      stateName: item.stateName,
      displayStateName: item.displayStateName,
    }))
    .concat(
      { stateName: "STUDENT", displayStateName: "Student" },
      { stateName: "CONTACT", displayStateName: "Contact" }
    );

  const leadStages =
    swimlaneData &&
    [...swimlaneData]?.sort((a: any, b: any) => {
      return a?.orderIndex - b?.orderIndex;
    });

  const sourceList = leadBoard?.sourceList;

  const filteredBranches = !hasAllBranchAccess
    ? branches
        ?.filter((d: any) => d?.id === user?.institute[0]?.branchId)
        ?.filter((branch: any) => {
          const searchTermMatch =
            branch.branchName
              .toLowerCase()
              .indexOf(branchSearchTerm.toLowerCase()) !== -1;

          return searchTermMatch;
        })
    : branches?.filter((branch: any) => {
        const searchTermMatch =
          branch.branchName
            .toLowerCase()
            .indexOf(branchSearchTerm.toLowerCase()) !== -1;

        return searchTermMatch;
      });

  useEffect(() => {
    /* 	if (location?.state?.isFromView === false && !hasAllBranchAccess) { */
    if (isFromView) {
      setLoadingForAdmin(true);
      if (batchList?.length > 0) {
        setIsAdminDataModified(true);
        setLoadingForAdmin(false);
      }
    }
  }, [batchList]);

  const filteredCourses =
    courses &&
    courses?.filter((item: any) => {
      const searchTermMatch =
        item.courseName
          .toLowerCase()
          .indexOf(courseSearchTerm.toLowerCase()) !== -1;

      return searchTermMatch;
    });

  const filteredSource =
    sourceList &&
    sourceList?.filter((item: any) => {
      const searchTermMatch = item.value
        .toLowerCase()
        .includes(sourceSearchTerm.toLowerCase());

      return searchTermMatch;
    });

  const filteredStage =
    leadStages &&
    leadStages?.filter((item: any) => {
      const searchTermMatch = item.displayStateName
        .toLowerCase()
        .includes(stageSearchTerm.toLowerCase());

      return searchTermMatch;
    });

  const handleFilterDateRangeChecked = (id: string, duration: string) => {
    const selectedRange = { id, duration };
    setCheckedDateRange([selectedRange]);
  };

  const filteredBatch = !hasAllBranchAccess
    ? batchList
        ?.filter((d: any) => d?.branchId === user?.institute[0]?.branchId)
        ?.filter(
          (item: any) =>
            item?.batchConductType === "REGULAR_BATCH" &&
            item?.batchStatus !== "CANCELLED" &&
            item?.status !== "INACTIVE"
        )
        ?.filter((batch: any) => {
          const searchTermMatch =
            batch.batchName
              .toLowerCase()
              .indexOf(batchSearchTerm.toLowerCase()) !== -1;

          return searchTermMatch;
        })
    : batchList
        ?.filter(
          (item: any) =>
            item?.batchConductType === "REGULAR_BATCH" &&
            /* 	item?.batchStatus === 'COMPLETED' && */
            item?.batchStatus !== "CANCELLED" &&
            item?.status !== "INACTIVE"
        )
        ?.filter((batch: any) => {
          const searchTermMatch =
            batch.batchName
              .toLowerCase()
              .indexOf(batchSearchTerm.toLowerCase()) !== -1;

          return searchTermMatch;
        });

  const handleAssigneeSearch = (event: any) => {
    setAssigneeSearchTerm(event.target.value);
  };

  const handleTagSearch = (event: any) => {
    setTagSearchTerm(event.target.value);
  };

  const handleSourceSearch = (event: any) => {
    setSourceSearchTerm(event.target.value);
  };

  const filteredEmployees = !hasAllBranchAccess
    ? employees
        ?.filter(
          (d: any) =>
            d?.branchId === user?.institute[0]?.branchId ||
            d?.allBranchAccess === true
        )
        ?.filter((item: any) => item.status === "ACTIVE")
        ?.filter((employee: any) => {
          const searchTermMatch =
            employee.firstName
              .toLowerCase()
              .indexOf(assigneeSearchTerm.toLowerCase()) !== -1;

          return searchTermMatch;
        })
    : employees
        ?.filter((item: any) => item.status === "ACTIVE")
        ?.filter((employee: any) => {
          const searchTermMatch =
            employee.firstName
              .toLowerCase()
              .indexOf(assigneeSearchTerm.toLowerCase()) !== -1;

          return searchTermMatch;
        });

  /* const filteredTags = profileTags.filter((tag) =>
		tag.label.toLowerCase().includes(tagSearchTerm.toLowerCase())
	); */

  const filteredTags =
    profileTags &&
    profileTags?.filter((item: any) => {
      const searchTermMatch = item.label
        .toLowerCase()
        .includes(tagSearchTerm.toLowerCase());

      return searchTermMatch;
    });

  const handleDateChange = (date: any, id: string) => {
    if (date !== null) {
      const dateUnix = date.unix();
      const dateMilliseconds = dateUnix * 1000;
      if (id === "startDate") {
        setStartDate(dateMilliseconds);
      } else if (id === "endDate") {
        setEndDate(dateMilliseconds);
      }
    }
  };
  const isCustomDate = checkedDateRange?.filter((d: any) => d?.id === "4");

  const onCancel = () => {
    setCancel(false);
  };

  const noCancelModal = () => {
    setCancel(false);
  };

  const yesCancelModal = () => {
    setCancel(false);
    localStorage.getItem("from") === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : localStorage.getItem("from") === "CreatedByMe"
      ? navigate("/app/Reports/CreatedByMe")
      : navigate("/app/Reports/AllReports");
    dispatch(resetReportStatuses());
  };

  useEffect(() => {
    if (getLatestReports) {
      setLoading(false);
      localStorage.getItem("from") === "RecentReports"
        ? navigate("/app/Reports/RecentReports")
        : localStorage.getItem("from") === "CreatedByMe"
        ? navigate("/app/Reports/CreatedByMe")
        : navigate("/app/Reports/AllReports");
    }
  }, [getLatestReports]);

  useEffect(() => {
    /* if (location?.state?.isFromView === false) { */
    if (isFromView === false) {
      reset();
    }
  }, [courses, batchList, branches, employees]);

  useEffect(() => {
    if (isFromView === true) {
      GetLeadReportById(location?.state?.id);
    }
  }, [location?.state, GetLeadReportById, isFromView]);

  useEffect(() => {
    if (getLeadReportByIdData) {
      setGraphValues(getLeadReportByIdData);
    }
  }, [getLeadReportByIdData]);

  useEffect(() => {
    setTimeout(() => {
      setShowClearAll(true);
    }, 8000);
  }, []);

  const reset = () => {
    const alllBranches =
      (filteredBranches &&
        filteredBranches?.map((d: any) => {
          return { id: d?.id, branchName: d?.branchName };
        })) ||
      [];
    setCheckedBranches([...alllBranches, { id: "0", branchName: "ALL" }]);
    const alllBatches =
      (filteredBatch &&
        filteredBatch?.map((d: any) => {
          return { id: d?.id, batchName: d?.batchName };
        })) ||
      [];
    setCheckedBatches([...alllBatches, { id: "0", batchName: "ALL" }]);
    const alllCourse =
      (filteredCourses &&
        filteredCourses?.map((d: any) => {
          return { id: d?.id, courseName: d?.courseName };
        })) ||
      [];
    setCheckedCourses([...alllCourse, { id: "0", courseName: "ALL" }]);
    const alllEmployees =
      (filteredEmployees &&
        filteredEmployees?.map((d: any) => {
          return { id: d?.id, firstName: d?.firstName, lastName: d?.lastName };
        })) ||
      [];
    setCheckedAssignees([
      ...alllEmployees,
      { id: "0", firstName: "ALL", lastName: "" },
    ]);
    const alllCategory =
      (subCategory &&
        subCategory?.map((d: any) => {
          return { id: d?.id, tagName: d?.tag };
        })) ||
      [];
    setCheckedTags(alllCategory);
    const allProfileTags =
      (filteredTags &&
        filteredTags?.map((d: any) => {
          return { label: d?.label, value: d?.value };
        })) ||
      [];
    setCheckedProfileTags([{ label: "All", value: "All" }, ...allProfileTags]);
    const allSources =
      (filteredSource &&
        filteredSource?.map((d: any) => {
          return { key: d?.key, value: d?.value };
        })) ||
      [];
    setCheckedSource([{ key: "ALL", value: "All" }, ...allSources]);
    const allStages =
      (filteredStage &&
        filteredStage?.map((d: any) => {
          return {
            stateName: d.stateName,
            displayStateName: d?.displayStateName,
          };
        })) ||
      [];
    setCheckedStage([
      { stateName: "ALL", displayStateName: "All" },
      ...allStages,
    ]);
    const allStatus =
      (status &&
        status?.map((d: any) => {
          return { type: d?.type, option: d?.option };
        })) ||
      [];
    setCheckedStatus(allStatus);
    setCheckedDateRange([{ duration: "Last 30 Days", id: "3" }]);
  };

  useEffect(() => {
    if (isFromView === false) {
      const data = {
        reportType: "LEAD",
        instituteId: user?.institute[0]?.instituteId,
        generateReports: true,
        courseId: "ALL",
        branchId: "ALL",
        batchId: "ALL",
        subCategory: "ALL",
        assignedToId: "ALL",
        enquiryProfileTag: "ALL",
        enquirySource: "ALL",
        enquirySwimlaneStatus: "ALL",
        status: ["ACTIVE", "LOST"],
      };

      if (hasAllBranchAccess) {
        GetDefaultReport(data);
      } else if (isAdimnDataModified) {
        const adminData = {
          reportType: "LEAD",
          instituteId: user?.institute[0]?.instituteId,
          generateReports: true,
          courseId: "ALL",
          branchId:
            filteredBranches &&
            filteredBranches?.map((d: any) => {
              return d?.id;
            }),
          batchId:
            filteredBatch &&
            filteredBatch?.map((d: any) => {
              return d?.id;
            }),
          subCategory: "ALL",
          assignedToId:
            filteredEmployees &&
            filteredEmployees?.map((d: any) => {
              return d?.id;
            }),
          enquiryProfileTag:
            filteredTags &&
            filteredTags?.map((d: any) => {
              return d?.value;
            }),
          enquirySource:
            filteredSource &&
            filteredSource?.map((d: any) => {
              return d?.key;
            }),
          enquirySwimlaneStatus:
            filteredStage &&
            filteredStage?.map((d: any) => {
              return d?.stateName;
            }),
          status: ["ACTIVE", "LOST"],
        };
        GetDefaultReport(adminData);
      }
    } else {
      const dataFromNavigateion = graphValues?.reportData?.appliedFilter;
      const branchIdArray = dataFromNavigateion?.find(
        (item: any) => item.branchId
      )?.branchId;
      const batchIdArray = dataFromNavigateion?.find(
        (item: any) => item.batchId
      )?.batchId;
      const courseIdArray = dataFromNavigateion?.find(
        (item: any) => item.courseId
      )?.courseId;
      const assigneeIdArray = dataFromNavigateion?.find(
        (item: any) => item.assignedToId
      )?.assignedToId;
      const subCategoryArray = dataFromNavigateion?.find(
        (item: any) => item.subCategory
      )?.subCategory;
      const enquiryProfileTagArray = dataFromNavigateion?.find(
        (item: any) => item.enquiryProfileTag
      )?.enquiryProfileTag;
      const enquirySourceArray = dataFromNavigateion?.find(
        (item: any) => item.enquirySource
      )?.enquirySource;

      const enquiryStageArray = dataFromNavigateion?.find(
        (item: any) => item.enquirySwimlaneStatus
      )?.enquirySwimlaneStatus;
      const statusArray = dataFromNavigateion?.find(
        (item: any) => item.status
      )?.status;
      const dateData = dataFromNavigateion?.find(
        (item: any) => item.date
      )?.date;

      if (dateData?.type === "today") {
        setCheckedDateRange([{ duration: "Today", id: "0" }]);
      } else if (dateData?.type === "day" && dateData?.value === 7) {
        setCheckedDateRange([{ duration: "Last 7 days", id: "1" }]);
      } else if (dateData?.type === "day" && dateData?.value === 15) {
        setCheckedDateRange([{ duration: "Last 15 Days", id: "2" }]);
      } else if (dateData?.type === "day" && dateData?.value === 30) {
        setCheckedDateRange([{ duration: "Last 30 Days", id: "3" }]);
      } else if (dateData?.type === "customDate") {
        setCheckedDateRange([{ duration: "Custom Date", id: "4" }]);
        setStartDate(dateData?.value);
      }

      if (
        branchIdArray === "ALL" ||
        branchIdArray?.length === filteredBranches?.length
      ) {
        const alllBranches =
          filteredBranches?.map((d: any) => {
            return { id: d?.id, branchName: d?.branchName };
          }) || [];
        setCheckedBranches([...alllBranches, { id: "0", branchName: "ALL" }]);
      } else {
        const aa = branchIdArray?.map((d: any) => {
          return { id: d, branchName: findNamesbyId("BRANCH", d) };
        });
        setCheckedBranches(aa);
      }
      if (
        batchIdArray === "ALL" ||
        batchIdArray?.length === filteredBatch?.length
      ) {
        const alllBatches =
          filteredBatch?.map((d: any) => {
            return { id: d?.id, batchName: d?.batchName };
          }) || [];
        setCheckedBatches([...alllBatches, { id: "0", batchName: "ALL" }]);
      } else {
        const aa = batchIdArray?.map((d: any) => {
          return { id: d, batchName: findNamesbyId("BATCH", d) };
        });
        setCheckedBatches(aa);
      }

      if (courseIdArray === "ALL") {
        const alllCourse =
          filteredCourses?.map((d: any) => {
            return { id: d?.id, courseName: d?.courseName };
          }) || [];
        setCheckedCourses([...alllCourse, { id: "0", courseName: "ALL" }]);
      } else {
        const aa = courseIdArray?.map((d: any) => {
          return { id: d, courseName: findNamesbyId("BATCH", d) };
        });
        setCheckedCourses(aa);
      }
      if (enquiryProfileTagArray === "ALL") {
        const alllProfileCategory =
          filteredTags?.map((d: any) => {
            return { label: d?.label, tagName: d?.value };
          }) || [];
        setCheckedProfileTags([
          { label: "All", value: "All" },
          ...alllProfileCategory,
        ]);
      } else {
        const selectedProfileTags = enquiryProfileTagArray?.map((d: any) => {
          return { label: d?.label, value: d?.value };
        });
        setCheckedProfileTags(selectedProfileTags);
      }
      if (
        assigneeIdArray === "ALL" ||
        assigneeIdArray?.length === filteredEmployees?.length
      ) {
        const alllEmployees =
          filteredEmployees?.map((d: any) => {
            return {
              id: d?.id,
              firstName: d?.firstName,
              lastName: d?.lastName,
            };
          }) || [];
        setCheckedAssignees([
          ...alllEmployees,
          { id: "0", firstName: "ALL", lastName: "" },
        ]);
      } else {
        const aa = assigneeIdArray?.map((d: any) => {
          const name = findNamesbyId("ASSIGNEE", d);
          const [firstName, lastName] = name.split(" ");
          return { id: d, firstName: firstName, lastName: lastName };
        });
        setCheckedAssignees(aa);
      }

      if (subCategoryArray === "ALL") {
        const alllCategory =
          subCategory?.map((d: any) => {
            return { id: d?.id, tagName: d?.tag };
          }) || [];
        setCheckedTags(alllCategory);
      } else {
        const aa = subCategoryArray?.map((d: any) => {
          return {
            id: d === "STUDENT_CONTACT" ? "1" : d === "ENQUIRY" ? "2" : "3",
            tagName:
              d === "STUDENT_CONTACT"
                ? "Contact"
                : d === "ENQUIRY"
                ? "Lead"
                : "3",
          };
        });
        setCheckedTags(aa);
      }

      if (enquirySourceArray === "ALL") {
        const allSourceCategory =
          filteredSource?.map((d: any) => ({
            key: d?.key,
            value: d?.value,
          })) || [];

        setCheckedSource([{ key: "ALL", value: "All" }, ...allSourceCategory]);
      } else {
        const selectedSource = enquirySourceArray?.map((d: any) => ({
          key: d?.key,
          value: d?.value,
        }));

        setCheckedSource(selectedSource);
      }
      if (enquiryStageArray === "ALL") {
        const allStageCategory =
          filteredStage?.map((d: any) => ({
            stateName: d?.stateName,
            displayStateName: d?.displayStateName,
          })) || [];

        setCheckedStage([
          { stateName: "ALL", displayStateName: "All" },
          ...allStageCategory,
        ]);
      } else {
        const selectedStage = enquiryStageArray?.map((d: any) => ({
          stateName: d?.stateName,
          displayStateName: d?.displayStateName,
        }));

        setCheckedStage(selectedStage);
      }
      if (
        Array.isArray(statusArray) &&
        statusArray.length === 2 &&
        statusArray.includes("ACTIVE") &&
        statusArray.includes("LOST")
      ) {
        const allStatusCategory =
          status?.map((d: any) => ({
            type: d?.type,
            option: d?.option,
          })) || [];

        setCheckedStatus([...allStatusCategory]);
      } else {
        const selectedStatus = statusArray?.map((d: any) => ({
          type: d?.type,
          option: d?.option,
        }));

        setCheckedStatus(selectedStatus);
      }
    }
  }, [isAdimnDataModified, graphValues]);

  const findNamesbyId = (fieldName: any, id: string) => {
    if (fieldName === "COURSE" && id) {
      const courseName =
        courseList &&
        courseList?.filter(
          (d: any) =>
            d?.id.toString().toLowerCase() === id.toString().toLowerCase()
        );
      return courseName && courseName[0]?.courseName;
    } else if (fieldName === "BATCH" && id) {
      const batchName =
        batchList &&
        batchList?.filter(
          (d: any) =>
            d?.id.toString().toLowerCase() === id.toString().toLowerCase()
        );

      return batchName && batchName[0]?.batchName;
    } else if (fieldName === "BRANCH" && id) {
      const branchName =
        filteredBranches && filteredBranches?.filter((d: any) => d?.id === id);
      return branchName && branchName[0]?.branchName;
    } else if (fieldName === "ASSIGNEE") {
      const assigneeName =
        filteredEmployees &&
        filteredEmployees?.filter((d: any) => d?.id === id);
      return (
        assigneeName &&
        `${assigneeName[0]?.firstName} ${assigneeName[0]?.lastName} `
      );
    }
  };

  useEffect(() => {
    if (getDefaultReportData) {
      setReportTableData(getDefaultReportData?.result);
    }
  }, [getDefaultReportData, isFromView]);

  const result =
    isFromView === true
      ? getLeadReportByIdData?.reportData?.result
      : reportTableData;

  const handleSaveClick = async (event: any) => {
    event.preventDefault();
    setLoading(true);
    const data = {
      instituteId: user?.institute[0]?.instituteId,
      name: reportName,
      category: "LEAD",
      description: description,
      reportData: {
        result: getDefaultReportData?.result,
        lineGraphData: getDefaultReportData?.lineGraphData,
        pieChartData: getDefaultReportData?.pieChartData,
        appliedFilter: getDefaultReportData?.appliedFilter,
      },
      createdById: user?.institute[0]?.id,
      createdByName: `${user?.institute[0]?.firstName} ${user?.institute[0]?.lastName}`,
    };
    SaveReport(data);
  };

  const handleFilterApply = () => {
    const hasAllBranches = checkedBranches?.some(
      (branch: any) => branch?.branchName === "ALL"
    );
    const hasAllBatches = checkedBatches?.some(
      (batch: any) => batch?.batchName === "ALL"
    );
    const hasAllCourses = checkedCourses.some(
      (course: any) => course.courseName === "ALL"
    );
    const hasAllCategory = checkedTags.some(
      (tags: any) => tags.tagName === "All"
    );
    const hasAllAssignees = checkedAssignees.some(
      (assignee: any) => assignee.firstName === "ALL"
    );

    const hasAllProfileTags = checkedProfileTags.some(
      (tag: any) => tag.value === "All"
    );
    const hasAllSource = checkedSource.some(
      (source: any) => source.key == "ALL"
    );
    const hasAllStage = checkedStage.some(
      (source: any) => source.stateName == "ALL"
    );
    const hasAllStatus =
      checkedStatus.includes("ACTIVE") && checkedStatus.includes("LOST");
    const date: any = new Date(startDate);
    const dateForDefaultReport = date.setUTCHours(0, 0, 0, 0);

    const today = new Date();

    const timestamp = Date.UTC(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getUTCDate()
    );
    const data = {
      reportType: "LEAD",
      instituteId: user?.institute[0]?.instituteId,
      generateReports: true,
      courseId: hasAllCourses ? "ALL" : checkedCourses?.map((d: any) => d?.id),
      branchId: !hasAllBranchAccess
        ? checkedBranches
            ?.filter((d: any) => d?.id !== "0")
            ?.map((d: any) => d?.id)
        : hasAllBranches
        ? "ALL"
        : checkedBranches?.map((d: any) => d?.id),
      batchId: !hasAllBranchAccess
        ? checkedBatches
            ?.filter((d: any) => d?.id !== "0")
            ?.map((d: any) => d?.id)
        : hasAllBatches
        ? "ALL"
        : checkedBatches?.map((d: any) => d?.id),
      subCategory: hasAllCategory
        ? "ALL"
        : checkedTags
            ?.filter((ds: any) => ds?.tagName !== "ALL")
            ?.map((d: any) => {
              return d?.tagName === "Contact"
                ? "STUDENT_CONTACT"
                : d?.tagName === "Lead"
                ? "ENQUIRY"
                : "BATCHSTUDENTMAPPING";
            }),
      enquiryProfileTag: hasAllProfileTags
        ? "ALL"
        : checkedProfileTags
            ?.filter((ds: any) => ds?.value !== "ALL")
            ?.map((d: any) => {
              return d?.value;
            }),
      enquirySource: hasAllSource
        ? "ALL"
        : checkedSource
            ?.filter((ds: any) => ds?.key !== "ALL")
            ?.map((d: any) => {
              return d?.key;
            }),
      enquirySwimlaneStatus: hasAllStage
        ? "ALL"
        : checkedStage
            ?.filter((ds: any) => ds?.stateName !== "ALL")
            ?.map((d: any) => {
              return d?.stateName;
            }),

      status: hasAllStatus
        ? ["ACTIVE", "LOST"]
        : checkedStatus?.map((d: any) => {
            return d?.type;
          }),
      assignedToId: !hasAllBranchAccess
        ? checkedAssignees
            ?.filter((d: any) => d?.id !== "0")
            ?.map((d: any) => d?.id)
        : hasAllAssignees
        ? "ALL"
        : checkedAssignees?.map((d: any) => d?.id),
      date: checkedDateRange?.some((item: any) => item.duration === "Today")
        ? { type: "today", value: timestamp }
        : checkedDateRange?.some((item: any) => item.duration === "Custom Date")
        ? { type: "customDate", value: dateForDefaultReport }
        : checkedDateRange?.some((item: any) => item.duration === "Last 7 days")
        ? { type: "day", value: 7 }
        : checkedDateRange?.some(
            (item: any) => item.duration === "Last 15 Days"
          )
        ? { type: "day", value: 15 }
        : checkedDateRange?.some(
            (item: any) => item.duration === "Last 15 Days"
          )
        ? { type: "day", value: 30 }
        : "",
    };
    if (data?.subCategory === "" || data?.subCategory?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select subcategory filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (data?.branchId === "" || data?.branchId?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select branch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (data?.courseId === "" || data?.courseId?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select course filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (data?.assignedToId === "" || data?.assignedToId?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select assignee filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (data?.status?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select status filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (
      data?.enquiryProfileTag === "" ||
      data?.enquiryProfileTag?.length === 0
    ) {
      dispatch(
        setToastNotification({
          message: "Please select tag filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (
      data?.enquirySource === "" ||
      data?.enquirySource?.length === 0
    ) {
      dispatch(
        setToastNotification({
          message: "Please select source filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (
      data?.enquirySwimlaneStatus === "" ||
      data?.enquirySwimlaneStatus?.length === 0
    ) {
      dispatch(
        setToastNotification({
          message: "Please select stage filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else {
      GetDefaultReport(data);
    }
  };

  const handleFilterBranchChecked = (id: string, branchName: string) => {
    if (branchName === "All") {
      if (
        checkedBranches.length ===
        [{ id: "0", branchName: "All" }, ...filteredBranches].length
      ) {
        setCheckedBranches([]);
      } else {
        const alllBranches = filteredBranches?.map((d: any) => {
          return { id: d?.id, branchName: d?.branchName };
        });
        setCheckedBranches([...alllBranches, { id: "0", branchName: "ALL" }]);
      }
    } else {
      const branchToAdd: CheckedBranch = { id, branchName };
      const isAllSelected = checkedBranches.some(
        (branch) => branch.branchName === "ALL"
      );

      if (checkedBranches.some((branch) => branch.id === id)) {
        const updatedBranches = checkedBranches.filter(
          (branch) => branch.id !== id
        );
        if (isAllSelected) {
          setCheckedBranches(
            updatedBranches.filter((branch) => branch.branchName !== "ALL")
          );
        } else {
          setCheckedBranches(updatedBranches);
        }
      } else {
        setCheckedBranches([
          ...checkedBranches,
          branchToAdd,
          // { id: "0", branchName: "ALL" },
        ]);
      }
    }
  };
  const handleFilterCourseChecked = (id: string, courseName: string) => {
    if (courseName === "All") {
      if (
        checkedCourses.length ===
        [{ id: "0", courseName: "All" }, ...filteredCourses].length
      ) {
        setCheckedCourses([]);
      } else {
        const allCourse = filteredCourses?.map((d: any) => {
          return { id: d?.id, courseName: d?.branchName };
        });
        setCheckedCourses([...allCourse, { id: "0", courseName: "ALL" }]);
      }
    } else {
      const courseToAdd: CheckedCourse = { id, courseName };
      const isAllSelected = checkedCourses.some(
        (branch) => branch.courseName === "ALL"
      );

      if (checkedCourses.some((branch) => branch.id === id)) {
        const updatedCourses = checkedCourses.filter(
          (course) => course.id !== id
        );
        if (isAllSelected) {
          setCheckedCourses(
            updatedCourses.filter((course: any) => course.courseName !== "ALL")
          );
        } else {
          setCheckedCourses(updatedCourses);
        }
      } else {
        setCheckedCourses([...checkedCourses, courseToAdd]);
      }
    }
  };

  const handleFilterBatchChecked = (id: string, batchName: string) => {
    if (batchName === "All") {
      if (
        checkedBatches.length ===
        [{ id: "0", batchName: "All" }, ...filteredBatch].length
      ) {
        setCheckedBatches([]);
      } else {
        const allBatch = filteredBatch?.map((d: any) => {
          return { id: d?.id, batchName: d?.branchName };
        });
        setCheckedBatches([...allBatch, { id: "0", batchName: "ALL" }]);
      }
    } else {
      const batchToAdd: any = { id, batchName };
      const isAllSelected = checkedBatches.some(
        (batch) => batch.batchName === "ALL"
      );

      if (checkedBatches.some((branch) => branch.id === id)) {
        const updatedCourses = checkedBatches.filter(
          (course) => course.id !== id
        );
        if (isAllSelected) {
          setCheckedBatches(
            updatedCourses.filter((course: any) => course.batchName !== "ALL")
          );
        } else {
          setCheckedBatches(updatedCourses);
        }
      } else {
        setCheckedBatches([...checkedBatches, batchToAdd]);
      }
    }
  };

  const handleFilterAssigneeChecked = (
    id: string,
    firstName: string,
    lastName: string
  ) => {
    if (firstName === "All") {
      if (
        checkedAssignees.length ===
        [{ id: "0", firstName: "All", lastName: "" }, ...filteredEmployees]
          .length
      ) {
        setCheckedAssignees([]);
      } else {
        const allEmployees = filteredEmployees?.map((d: any) => {
          return { id: d?.id, firstName: d?.firstName, lastName: d?.lastName };
        });
        setCheckedAssignees([
          ...allEmployees,
          { id: "0", firstName: "ALL", lastName: "" },
        ]);
      }
    } else {
      const employeesToAdd: any = { id, firstName, lastName };
      const isAllSelected = checkedAssignees.some(
        (emp) => emp.firstName === "ALL"
      );

      if (checkedAssignees.some((emp) => emp.id === id)) {
        const updatedEmp = checkedAssignees.filter((emp) => emp.id !== id);
        if (isAllSelected) {
          setCheckedAssignees(
            updatedEmp.filter((emp: any) => emp.firstName !== "ALL")
          );
        } else {
          setCheckedAssignees(updatedEmp);
        }
      } else {
        setCheckedAssignees([...checkedAssignees, employeesToAdd]);
      }
    }
  };

  const handleFilterTagsChecked = (id: string, tagName: string) => {
    if (tagName === "All") {
      if (checkedTags.length === subCategory.length) {
        setCheckedTags([]);
      } else {
        const allCategory = subCategory?.map((d: any) => {
          return { id: d?.id, tagName: d?.tag };
        });
        setCheckedTags(allCategory);
      }
    } else {
      const tagsToAdd: any = { id, tagName };
      const isAllSelected = checkedTags.some((tag) => tag.tagName === "All");
      if (checkedTags.some((tag) => tag.id === id)) {
        const updatedTags = checkedTags.filter((tag) => tag.id !== id);
        if (isAllSelected) {
          setCheckedTags(
            updatedTags.filter((tag: any) => tag.tagName !== "All")
          );
        } else {
          setCheckedTags(updatedTags);
        }
      } else {
        setCheckedTags([...checkedTags, tagsToAdd]);
      }
    }
  };
  const handleFilterProfileTagsChecked = (label: string, value: string) => {
    if (label === "All") {
      if (
        checkedProfileTags.length ===
        [{ label: "All", value: "All" }, ...filteredTags].length
      ) {
        setCheckedProfileTags([]);
      } else {
        const allCategory = filteredTags?.map((d: any) => ({
          label: d?.label,
          value: d?.value,
        }));
        setCheckedProfileTags([{ label: "All", value: "All" }, ...allCategory]);
      }
    } else {
      const tagsProfilesToAdd: any = { label, value };
      const isAllSelected = checkedProfileTags.some(
        (tag) => tag.value === "All"
      );
      if (checkedProfileTags.some((tag) => tag.value === value)) {
        const updatedTags = checkedProfileTags.filter(
          (tag) => tag.value !== value
        );
        if (isAllSelected) {
          setCheckedProfileTags(
            updatedTags.filter((tag: any) => tag.value !== "All")
          );
        } else {
          setCheckedProfileTags(updatedTags);
        }
      } else {
        setCheckedProfileTags([...checkedProfileTags, tagsProfilesToAdd]);
      }
    }
  };

  const handleFilterSourceChecked = (key: string, value: string) => {
    if (key === "ALL") {
      if (
        checkedSource.length ===
        [{ key: "ALL", value: "All" }, ...filteredSource].length
      ) {
        setCheckedSource([]);
      } else {
        const allSource = filteredSource?.map((d: any) => {
          return { key: d?.key, value: d?.value };
        });
        setCheckedSource([...allSource, { key: "ALL", value: "All" }]);
      }
    } else {
      const sourcesToAdd: any = { key, value };
      const isAllSelected = checkedSource.some((tag) => tag.value === "All");
      if (checkedSource.some((item) => item.value === value)) {
        const updatedTags = checkedSource.filter((tag) => tag.value !== value);
        if (isAllSelected) {
          setCheckedSource(
            updatedTags.filter((tag: any) => tag.value !== "All")
          );
        } else {
          setCheckedSource(updatedTags);
        }
      } else {
        setCheckedSource([...checkedSource, sourcesToAdd]);
      }
    }
  };
  const handleFilterStageChecked = (
    stateName: string,
    displayStateName: string
  ) => {
    if (stateName === "ALL") {
      if (
        checkedStage.length ===
        [{ stateName: "ALL", displayStateName: "All" }, ...filteredStage].length
      ) {
        setCheckedStage([]);
      } else {
        const allStage = filteredStage?.map((d: any) => {
          return {
            stateName: d?.stateName,
            displayStateName: d?.displayStateName,
          };
        });
        setCheckedStage([
          ...allStage,
          { stateName: "ALL", displayStateName: "All" },
        ]);
      }
    } else {
      const stagesToAdd: any = { stateName, displayStateName };
      const isAllSelected = checkedStage.some(
        (tag) => tag.displayStateName === "All"
      );
      if (
        checkedStage.some((item) => item.displayStateName === displayStateName)
      ) {
        const updatedTags = checkedStage.filter(
          (tag) => tag.displayStateName !== displayStateName
        );
        if (isAllSelected) {
          setCheckedStage(
            updatedTags.filter((tag: any) => tag.displayStateName !== "All")
          );
        } else {
          setCheckedStage(updatedTags);
        }
      } else {
        setCheckedStage([...checkedStage, stagesToAdd]);
      }
    }
  };
  const handleFilterStatusChecked = (type: string, option: string) => {
    let updatedStatus = [...checkedStatus];
    const isSelected = updatedStatus.some((tag) => tag.type === type);

    if (isSelected) {
      if (updatedStatus.length > 1) {
        updatedStatus = updatedStatus.filter((tag) => tag.type !== type);
      }
    } else {
      updatedStatus.push({ type, option });
    }

    setCheckedStatus(updatedStatus);
  };

  const handleDownload = () => {
    const flatttenedArray = getDefaultReportData?.result.flatMap(
      (item: any) => item
    );

    const data = {
      action: "DOWNLOAD",
      reportType: "LEAD",
      instituteId: user?.institute[0]?.instituteId,
      reportData: flatttenedArray,
    };

    DownloadReport(data)
      .then((res: any) => {
        const blob = base64ToBlob(
          res?.data?.data?.fileBase64String,
          "application/vnd.ms-excel"
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "leadReport.xlsx";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        dispatch(
          setToastNotification({
            message: "Congratulations! Report is successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
      })
      .catch((err: any) => {});
  };

  const base64ToBlob = (base64Data: string, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  useEffect(() => {
    if (downloadReportSuccess) {
      const blob = base64ToBlob(
        downloadReportData?.fileBase64String,
        "application/vnd.ms-excel"
      );
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "leadReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      dispatch(resetDownloadReportSuccess());
    }
  }, [downloadReportSuccess]);

  const [visibleCount, setVisibleCount] = useState(100);
  const containerRef = useRef<HTMLDivElement | null>(null);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + window.scrollY >=
  //       document.body.offsetHeight - 200
  //     ) {
  //       // load 100 more rows when near bottom
  //       setVisibleCount((prev) => Math?.min(prev + 100, result?.length));
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [result?.length]);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        setVisibleCount((prev) => Math.min(prev + 100, result?.length ?? 0));
      }
    };

    const el = containerRef.current;
    el?.addEventListener("scroll", handleScroll);

    return () => el?.removeEventListener("scroll", handleScroll);
  }, [result?.length]);

  return (
    <Box
      sx={{
        overflow: "hidden",
        padding: "14px 16px",
        background: "#EEEEEE",
        // maxHeight: "calc(100vh - 65px)",
        // position: "relative",
        maxHeight: "90vh",
        position: "relative",
        scrollbarWidth: "none",
      }}
    >
      {getDefaultReportDataLoading ||
      loadingForAdmin ||
      getLeadReportByIdLoading ? (
        <AttendanceSkeleton />
      ) : (
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
            display: "flex",
            width: getDefaultReportDataLoading
              ? "84vw"
              : isCompress
              ? "78vw"
              : "70vw",
            maxHeight: "100vh",
            minHeight: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <Box
            sx={{
              background: "#fff",
              minWidth: "219px",
              borderRight: "1px solid #E9E9E9",
              // overflowY: "hidden",
            }}
            className="datepicker-container"
          >
            <div className={styles.calendarHeader}>
              <div className={styles.headerText}>Custom</div>
            </div>
            <div className={styles.applyClearSection}>
              {/* 	{location?.state?.isFromView === false && ( */}
              {isFromView === false && (
                <>
                  {showClearAll ? (
                    <div
                      className={styles.clearFilterText}
                      onClick={() => {
                        setCheckedTags([]);
                        setCheckedBranches([]);
                        setCheckedBatches([]);
                        setCheckedCourses([]);
                        setCheckedAssignees([]);
                        setCheckedDateRange([]);
                        setCheckedProfileTags([]);
                        setCheckedSource([]);
                        setCheckedStage([]);
                        setCheckedStatus([]);
                      }}
                    >
                      Clear All
                    </div>
                  ) : (
                    <div className={styles.clearFilterText}></div>
                  )}
                  <div
                    className={styles.applyFilterText}
                    onClick={() => {
                      handleFilterApply();
                      setIsBranchOpen(false);
                      setIsBatchOpen(false);
                      setIsCourseOpen(false);
                      setIsAssigneeOpen(false);
                      setIsTypeOpen(false);
                      setIsDateOpen(false);
                      setIsProfileTagOpen(false);
                      setIsSourceOpen(false);
                      setIsStageOpen(false);
                      setIsStatusOpen(false);
                    }}
                  >
                    Apply
                  </div>
                </>
              )}
            </div>
            <div className={styles.filterContainer}>
              <CustomFilterAccordion
                title="Sub Category"
                isOpen={isTypeOpen}
                setIsOpen={setIsTypeOpen}
                count={checkedTags?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {subCategory?.map((item: any) => (
                        <FilterCheckbox
                          key={item.id}
                          keyVal={item.id}
                          checked={checkedTags?.some(
                            (data: any) => data?.id === item?.id
                          )}
                          checkboxFunction={() =>
                            handleFilterTagsChecked(item.id, item.tag)
                          }
                          label={item?.tag?.toLowerCase()}
                          fromReports={true}
                          disable={isFromView === true ? true : false}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Branch"
                isOpen={isBranchOpen}
                setIsOpen={setIsBranchOpen}
                count={checkedBranches?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={branchSearchTerm}
                    onChange={(e: any) => {
                      setBranchSearchTerm(e.target.value);
                    }}
                    placeholder="Search Branch"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {branches &&
                        [
                          { branchName: "All", id: "0" },
                          ...filteredBranches,
                        ]?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item?.id}
                            checked={checkedBranches?.some(
                              (data) => data?.id === item?.id
                            )}
                            checkboxFunction={() =>
                              handleFilterBranchChecked(
                                item.id,
                                item.branchName
                              )
                            }
                            label={item?.branchName?.toLowerCase()}
                            fromReports={true}
                            disable={isFromView === true}
                            isBatchCompleted={
                              item?.batchStatus === "COMPLETED" ? true : false
                            }
                          />
                        ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Course"
                isOpen={isCourseOpen}
                setIsOpen={setIsCourseOpen}
                count={checkedCourses?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={courseSearchTerm}
                    onChange={(e: any) => {
                      setCourseSearchTerm(e.target.value);
                    }}
                    placeholder="Search Course"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {courseList &&
                        [
                          { courseName: "All", id: "0" },
                          ...filteredCourses,
                        ]?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item?.id}
                            checked={checkedCourses?.some(
                              (data) => data?.id === item?.id
                            )}
                            checkboxFunction={() =>
                              handleFilterCourseChecked(
                                item.id,
                                item.courseName
                              )
                            }
                            label={item?.courseName?.toLowerCase()}
                            fromReports={true}
                            disable={isFromView === true}
                          />
                        ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Batch"
                isOpen={isBatchOpen}
                setIsOpen={setIsBatchOpen}
                count={checkedBatches?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={batchSearchTerm}
                    onChange={(e: any) => setBatchSearchTerm(e.target.value)}
                    placeholder="Search Batch"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {batchList &&
                        [{ batchName: "All", id: "0" }, ...filteredBatch]?.map(
                          (item: any) => (
                            <FilterCheckbox
                              key={item.id}
                              keyVal={item.id}
                              checked={checkedBatches?.some(
                                (data) => data?.id === item?.id
                              )}
                              checkboxFunction={() =>
                                handleFilterBatchChecked(
                                  item.id,
                                  item.batchName
                                )
                              }
                              isBatchCompleted={
                                item?.batchStatus === "COMPLETED" ? true : false
                              }
                              label={item.batchName.toLowerCase()}
                              fromReports={true}
                              disable={isFromView === true}
                            />
                          )
                        )}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Assignee"
                isOpen={isAssigneeOpen}
                setIsOpen={setIsAssigneeOpen}
                count={checkedAssignees?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={assigneeSearchTerm}
                    onChange={handleAssigneeSearch}
                    placeholder="Search Assignee"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {employees &&
                        [
                          { firstName: "All", lastName: "", id: "0" },
                          ...filteredEmployees,
                        ]?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item.id}
                            checked={checkedAssignees?.some(
                              (data) => data?.id === item?.id
                            )}
                            checkboxFunction={() =>
                              handleFilterAssigneeChecked(
                                item.id,
                                item.firstName,
                                item.lastName
                              )
                            }
                            label={
                              item.firstName.toLowerCase() +
                              " " +
                              item.lastName.toLowerCase()
                            }
                            fromReports={true}
                            disable={isFromView === true}
                          />
                        ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Date"
                isOpen={isDateOpen}
                setIsOpen={setIsDateOpen}
                count={checkedDateRange?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {customDurationArray?.map((item: any) => (
                        <FilterCheckbox
                          key={item.id}
                          keyVal={item.id}
                          checked={checkedDateRange?.some(
                            (data: any) => data?.id === item?.id
                          )}
                          checkboxFunction={() =>
                            handleFilterDateRangeChecked(item.id, item.duration)
                          }
                          label={item?.duration?.toLowerCase()}
                          fromReports={true}
                          disable={isFromView === true}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
                {isCustomDate?.length > 0 && (
                  <Box
                    sx={{
                      marginTop: "5px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{
                          /* 	zIndex: '999999999 !important', */
                          minHeight: "20px",
                          ".MuiInputBase-root": {
                            fontSize: "12px",
                            minHeight: "20px",
                          },
                          ".MuiFormLabel-root": {
                            fontSize: "12px",
                            lineHeight: "1",
                          },
                          ".MuiSvgIcon-root": {
                            fontSize: "18px",
                          },
                          marginBottom: "10px",
                        }}
                        label="From"
                        format="DD/MM/YYYY"
                        onChange={(date) => handleDateChange(date, "startDate")}
                        value={
                          startDate !== null
                            ? dayjs.unix(startDate / 1000)
                            : null
                        }
                        disableFuture={true}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{
                          /* zIndex: '99999999 !important', */
                          minHeight: "20px",
                          ".MuiInputBase-root": {
                            fontSize: "12px",
                            minHeight: "20px",
                          },
                          ".MuiFormLabel-root": {
                            fontSize: "12px",
                            lineHeight: "1",
                          },
                          ".MuiSvgIcon-root": {
                            fontSize: "18px",
                          },
                        }}
                        label="To"
                        format="DD/MM/YYYY"
                        onChange={(date) => handleDateChange(date, "endDate")}
                        value={
                          endDate !== null ? dayjs.unix(endDate / 1000) : null
                        }
                        disabled={true}
                      />
                    </LocalizationProvider>
                  </Box>
                )}
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Tags"
                isOpen={isProfileTagOpen}
                setIsOpen={setIsProfileTagOpen}
                count={checkedProfileTags?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={tagSearchTerm}
                    onChange={handleTagSearch}
                    placeholder="Search Tag"
                  />
                  <FilterCheckBoxWrap>
                    {filteredTags &&
                      [{ label: "All", value: "All" }, ...filteredTags]?.map(
                        (item: any) => {
                          return (
                            <FilterCheckbox
                              key={item.value}
                              keyVal={item.value}
                              checked={checkedProfileTags?.some(
                                (data: any) => data?.value === item?.value
                              )}
                              checkboxFunction={() =>
                                handleFilterProfileTagsChecked(
                                  item.label,
                                  item.value
                                )
                              }
                              label={item?.label?.toLowerCase()}
                              fromReports={true}
                              disable={isFromView === true ? true : false}
                            />
                          );
                        }
                      )}
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Source"
                isOpen={isSourceOpen}
                setIsOpen={setIsSourceOpen}
                count={checkedSource?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={sourceSearchTerm}
                    onChange={handleSourceSearch}
                    placeholder="Search Source"
                  />
                  <FilterCheckBoxWrap>
                    {filteredSource &&
                      [{ key: "ALL", value: "All" }, ...filteredSource]?.map(
                        (item: any) => {
                          return (
                            <FilterCheckbox
                              key={item.value}
                              keyVal={item.value}
                              checked={checkedSource?.some(
                                (data: any) => data?.key === item?.key
                              )}
                              checkboxFunction={() =>
                                handleFilterSourceChecked(item.key, item.value)
                              }
                              label={item?.value?.toLowerCase()}
                              fromReports={true}
                              disable={isFromView === true ? true : false}
                            />
                          );
                        }
                      )}
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Stage"
                isOpen={isStageOpen}
                setIsOpen={setIsStageOpen}
                count={checkedStage?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={stageSearchTerm}
                    onChange={(e: any) => setStageSearchTerm(e.target.value)}
                    placeholder="Search Stage"
                  />
                  <FilterCheckBoxWrap>
                    {filteredStage &&
                      [
                        { stateName: "ALL", displayStateName: "All" },
                        ...filteredStage,
                      ]?.map((item: any) => {
                        return (
                          <FilterCheckbox
                            key={item.displayStateName}
                            keyVal={item.displayStateName}
                            checked={checkedStage?.some(
                              (data: any) => data?.stateName === item?.stateName
                            )}
                            checkboxFunction={() =>
                              handleFilterStageChecked(
                                item.stateName,
                                item.displayStateName
                              )
                            }
                            label={item?.displayStateName?.toLowerCase()}
                            fromReports={true}
                            disable={isFromView === true ? true : false}
                          />
                        );
                      })}
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
              <CustomFilterAccordion
                title="Status"
                isOpen={isStatusOpen}
                setIsOpen={setIsStatusOpen}
                count={checkedStatus?.length}
                disabled={isFromView === true}
              >
                <FilterTypeWrap>
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {status?.map((item: any) => (
                        <FilterCheckbox
                          key={item.id}
                          keyVal={item.id}
                          checked={checkedStatus?.some(
                            (data: any) => data?.type === item?.type
                          )}
                          checkboxFunction={() =>
                            handleFilterStatusChecked(item.type, item.option)
                          }
                          label={item?.option?.toLowerCase()}
                          fromReports={true}
                          disable={isFromView === true ? true : false}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
            </div>
          </Box>

          <Box
            sx={{
              background: "#fff",
              width: "100%",
            }}
          >
            {isFromView ? (
              <div className={styles.batchHeader}>
                <PageBackBtn
                  onClick={() => {
                    location?.state?.from === "RecentReports"
                      ? navigate("/app/Reports/RecentReports")
                      : location?.state?.from === "CreatedByMe"
                      ? navigate("/app/Reports/CreatedByMe")
                      : navigate("/app/Reports/AllReports");
                  }}
                  iconOnly={true}
                />
                <div className={styles.headerText}>
                  {`${location?.state?.reportName}`}
                </div>
                <button
                  className={styles.graphCollapseBtn}
                  onClick={() => setCollapseGraph(!collapseGraph)}
                >
                  Graph{" "}
                  <img
                    src={accordionDown}
                    alt=""
                    style={{
                      marginLeft: "5px",
                      transform: collapseGraph ? "rotate(180deg)" : "none",
                      transition: "0.2s ease-in-out",
                    }}
                  />
                </button>
              </div>
            ) : (
              <div className={styles.batchHeader}>
                <div className={styles.headerText}>
                  {isFromView
                    ? `${location?.state?.reportName}`
                    : "Report - Leads"}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <button
                    className={styles.graphCollapseBtn}
                    onClick={() => setCollapseGraph(!collapseGraph)}
                  >
                    Graph{" "}
                    <img
                      src={accordionDown}
                      alt=""
                      style={{
                        marginLeft: "5px",
                        transform: collapseGraph ? "rotate(180deg)" : "none",
                        transition: "0.2s ease-in-out",
                      }}
                    />
                  </button>

                  <CancelBtn
                    onClick={() => {
                      setCancel(true);
                    }}
                  />
                  <SaveBtn
                    onClick={() => {
                      setOpenSaveReportPopup(true);
                    }}
                    disabled={result?.length === 0}
                  />
                  <div style={{ marginLeft: "5px" }}>
                    <IconDropdown
                      options={[
                        {
                          label: "Download",
                          onClick: () => {
                            handleDownload();
                          },
                          style: { color: "#667085" },
                        },
                      ]}
                      isDownloadButton={true}
                      disabled={result?.length === 0}
                    />
                  </div>
                </div>
              </div>
            )}
            <div
              style={{
                overflowY: "scroll",
                height: "78vh",
              }}
            >
              <div
                className={styles.graphContainer}
                style={{
                  margin: collapseGraph ? "20px 20px" : "10px 20px",
                }}
              >
                {getDefaultReportDataLoading ? (
                  <CourseDescriptionSkeleton />
                ) : (
                  <>
                    {collapseGraph && (
                      <div className={styles.lineGraphContainer}>
                        <LineChart
                          result={
                            isFromView === true
                              ? graphValues?.reportData
                              : getDefaultReportData && getDefaultReportData
                          }
                          getDefaultReportDataLoading={
                            getDefaultReportDataLoading
                          }
                        />
                      </div>
                    )}
                  </>
                )}
                {getDefaultReportDataLoading ? (
                  <CourseDescriptionSkeleton />
                ) : (
                  <>
                    {collapseGraph && (
                      <div className={styles.pieGraphContainer}>
                        <PieChart
                          title={"lead"}
                          result={
                            isFromView === true
                              ? graphValues?.reportData
                              : getDefaultReportData && getDefaultReportData
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              <div
                style={{
                  margin: collapseGraph ? "30px 20px" : "10px 20px",
                }}
              >
                {getDefaultReportDataLoading ? (
                  <TableSkeleton />
                ) : (
                  <TableContainer
                    ref={containerRef}
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      border: "1px solid #EAECF0",
                      height: "calc(100vh - 100px)",
                      overflowY: "scroll",
                      boxShadow: "none",
                      flexGrow: 1,
                      width: "100%",
                      maxHeight: "calc(100vh - 220px)",
                      minHeight: "calc(100vh - 220px)",
                    }}
                  >
                    <Table sx={{ minWidth: 700 }}>
                      <TableHead
                        sx={{
                          position: "sticky",
                          top: 0,
                          zIndex: 999,
                        }}
                      >
                        <TableRow>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 50,
                            }}
                          >
                            #
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 300,
                            }}
                          >
                            Name{" "}
                            {`${
                              result?.length > 0
                                ? `(${result?.length})`
                                : `(${0})`
                            }`}
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 150,
                            }}
                          >
                            Stage
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 150,
                            }}
                          >
                            Assignee
                          </StyledTableCellHead>

                          <StyledTableCellHead
                            sx={{
                              minWidth: 150,
                            }}
                          >
                            Course Name
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Batch
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 150,
                            }}
                          >
                            Batch Status
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Branch
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Tag
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Last Activity
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Last Note
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Source
                          </StyledTableCellHead>
                          <StyledTableCellHead
                            sx={{
                              minWidth: 200,
                            }}
                          >
                            Lead Creation Date
                          </StyledTableCellHead>
                          {/* <StyledTableCellHead
														sx={{
															minWidth: 200,
														}}>
														Stage
													</StyledTableCellHead> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {result &&
                          result
                            ?.slice(0, visibleCount)
                            ?.map((report: any, index: any) => (
                              <TableRow key={index}>
                                <StyledTableCellBody
                                  sx={{
                                    color: "#142C44",
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {index + 1}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    color: "#142C44",
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {`${report?.firstName} ${report?.lastName}`}
                                      <div
                                        style={{
                                          marginLeft: "10px",
                                        }}
                                      >
                                        <Avatar
                                          sx={{
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            fontSize: "12px",
                                            background: "#EEEEF4",
                                            border: "2px solid #FFF",
                                            fontFamily: "Poppins",
                                            fontWeight: "400",
                                            color: "#667085",
                                            position: "relative",
                                          }}
                                        >
                                          {report?.entityType === "ENQUIRY"
                                            ? "L"
                                            : report?.entityType ===
                                              "BATCHSTUDENTMAPPING"
                                            ? "S"
                                            : "C"}
                                        </Avatar>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        color: "#667085",
                                        fontSize: "13px",
                                        textTransform: "lowercase",
                                      }}
                                    >
                                      {report?.email}{" "}
                                      {report?.email && report?.contact
                                        ? "|"
                                        : ""}{" "}
                                      {report?.contact
                                        ? `+${
                                            report?.contactCountryCode || "91"
                                          } ${
                                            report?.contactCountryCode
                                              ? report?.contact?.replace(
                                                  report?.contactCountryCode,
                                                  ""
                                                )
                                              : report?.contact?.startsWith(
                                                  "91"
                                                )
                                              ? report?.contact?.replace(
                                                  "91",
                                                  ""
                                                )
                                              : report?.contact
                                          }`
                                        : "-"}
                                    </div>
                                  </div>
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.enquirySwimlaneStatus}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.assignedToName}
                                </StyledTableCellBody>

                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.courseName}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report.batchName}
                                </StyledTableCellBody>
                                <StyledTableCellBody>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    <Box
                                      ml={1}
                                      sx={{
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {report.batchStatus}
                                    </Box>
                                  </Box>
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report.branchName}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.enquiryProfileTag === ""
                                    ? "-"
                                    : report?.enquiryProfileTag === "SELECT"
                                    ? "Select"
                                    : report?.enquiryProfileTag === "COLD"
                                    ? "Cold"
                                    : report?.enquiryProfileTag === "WARM"
                                    ? "Warm"
                                    : report?.enquiryProfileTag === "HOT"
                                    ? "Hot"
                                    : report?.enquiryProfileTag === "INTERESTED"
                                    ? "Interested"
                                    : report?.enquiryProfileTag === "FOLLOWUP"
                                    ? "Followup"
                                    : report?.enquiryProfileTag === "INVALID"
                                    ? "Invalid"
                                    : report?.enquiryProfileTag ===
                                      "DISQUALIFIED"
                                    ? "Disqualified"
                                    : report?.enquiryProfileTag ===
                                      "NOT_ANSWERING"
                                    ? "Not Answering"
                                    : report?.enquiryProfileTag ===
                                      "NOT_INTERESTED"
                                    ? "Not Interested"
                                    : report?.enquiryProfileTag ===
                                      "FUTURE_PROSPECT"
                                    ? "Future Prospect"
                                    : report?.enquiryProfileTag ===
                                      "BUDGET_CONSTRAINT"
                                    ? "Budget Constraint"
                                    : report?.enquiryProfileTag ===
                                      "NOT_REACHABLE"
                                    ? "Not Reachable"
                                    : report?.enquiryProfileTag === "LOST"
                                    ? "Lost"
                                    : report?.enquiryProfileTag ===
                                      "SHORTLISTED"
                                    ? "Shortlisted"
                                    : report?.enquiryProfileTag === "ADMISSION"
                                    ? "Admission"
                                    : report?.enquiryProfileTag ===
                                      "DISCONTINUED"
                                    ? "Discontinued"
                                    : report?.enquiryProfileTag ===
                                      "DISCONTINUED_REFUNDED"
                                    ? "Discontinued and Refunded"
                                    : ""}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.lastActivityDate === ""
                                    ? "-"
                                    : moment(report?.lastActivityDate).format(
                                        "DD MMM YYYY, hh:mm A "
                                      )}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.lastNote ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          getDescriptionWithMentionedNames(
                                            report?.lastNote,
                                            employees
                                          ).replace(/\n/g, "<br>"),
                                      }}
                                    ></div>
                                  ) : (
                                    "-"
                                  )}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.enquirySource}
                                </StyledTableCellBody>
                                <StyledTableCellBody
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: "14px",
                                  }}
                                >
                                  {report?.createdDate === ""
                                    ? "-"
                                    : moment(report?.createdDate).format(
                                        "DD MMM YYYY, hh:mm A "
                                      )}
                                </StyledTableCellBody>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </div>
            </div>
          </Box>
        </Box>
      )}
      {openSaveReportPopup && (
        <SaveReportPopup
          openSaveReportPopup={openSaveReportPopup}
          setOpenSaveReportPopup={setOpenSaveReportPopup}
          handleSaveClick={handleSaveClick}
          saveReportLoading={loading}
          description={description}
          setDescription={setDescription}
          reportName={reportName}
          setReportName={setReportName}
        />
      )}

      <CancelModal
        open={cancel}
        onClose={onCancel}
        noButtonClick={noCancelModal}
        yesButtonClick={yesCancelModal}
        subTitle=""
        title={`Do you really want to close the report without saving it!!!`}
      />
    </Box>
  );
};

export default LeadReportCreation;
